import {styled} from '@innowise-group/ui-kit';

export const FloorFieldForm = styled.div`
  width: 50%;
`;
